<template>
  <div class="table-container">
    <!-- <div v-if="loading == true"> -->
      <SkeletonForReport 
        v-if="loading"
        :size="98"
        text="Fetching data"
      />
    <!-- </div> -->
    <table v-else>
      <thead v-if="accounData && accounData.length">
        <tr>
          <th class="first-column"></th>
          <th class="headerElem" v-for="project in projectData" :key="project.id">

            <span class="sort-top">
              <i :class="[
                'pi',
                sortId === project.id
                  ? (sortDirection === 'asc' ? 'pi-sort-numeric-up' : 'pi-sort-numeric-down-alt')
                  : 'pi-sort-numeric-down-alt',
                'show-cursor'
              ]" @click="getSortTheData(project.id)"></i>
            </span>
            <div class="headerText">
              <span>{{ getProjectData(project.code) }}
                <v-tooltip activator="parent">{{ project.code }}</v-tooltip>
              </span>
            </div>

          </th>
          <th class="headerElem total-column total-header-cell">
            <span class="sort-top">
              <i :class="['pi', totalSortDirection !== 'asc' ? 'pi-sort-numeric-up' : 'pi-sort-numeric-down-alt', 'show-cursor']"
                @click="getSortTheTotalData()"></i>
            </span>
            <div class="headerText total-header">Total</div>
          </th>

        </tr>
      </thead>
     <tbody class="scrollable-body">
        <template v-if="accounData && accounData.length">
          <tr v-for="account in accounData" :key="account.id">
            <td>
              <span class="headerElem account-name" style="font-weight: bold">
                {{ account.name }}
              </span>
            </td>

            <td v-for="project in projectData" :key="project.id">
              <div
                class="project-cell"
                style="font-weight: bold; cursor: pointer"
                @click="issueData(project.id, account.id)"
              >
                {{ getCellValue(project.id, account.id) || "-" }}
              </div>
            </td>

            <td class="total-column-cell">
              <span
                style="font-weight: bold; cursor: pointer"
                @click="issueData(null, account.id)"
              >
                {{ getAccountTotal(account.id) }}
              </span>
            </td>
          </tr>
        </template>

        <tr v-else>
          <td :colspan="projectData.length + 2" class="no-data-cell">
            <div class="empty-state">
              <div class="empty-visual">
                <span class="empty-orbit empty-orbit-one"></span>
                <span class="empty-orbit empty-orbit-two"></span>

                <div class="empty-icon-card">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <rect x="3" y="4" width="18" height="16" rx="2.5" />
                    <path d="M3 10h18" />
                    <path d="M9 4v6m6-6v6" />
                    <path d="M8 14h.01M12 14h.01M16 14h.01" />
                    <path d="M8 17h.01M12 17h.01" />
                  </svg>
                </div>

                <span class="empty-spark spark-one"></span>
                <span class="empty-spark spark-two"></span>
                <span class="empty-spark spark-three"></span>
              </div>

              <div class="empty-state-title">Nothing to display yet</div>

              <div class="empty-state-description">
                No records were found for the current selection.
              </div>

              <div class="empty-state-badge">
                <span class="status-dot"></span>
                No records available
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="total-row">
          <td class="total-column-cell">Total</td>
          <td style="background-color: #eef6fb;width: 30px;" class="total-column-cell" v-for="project in projectData"
            :key="project.id">
            <span style="font-weight: bold;cursor: pointer;" @click="issueData(project.id, null)">
              {{
                this.switchData === "estimate"
                  ? getProjectTotal(project.id)
                  : getProjectTotal(project.id)
              }}</span>
          </td>
          <td class="total-column-cell">
            <span style="font-weight: bold">
              {{ this.switchData === "estimate" ? getTotal() : getTotal() }}
            </span>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import ProductionDashboardService from "@/api/service/ProductionDashboard/ProductionDashboard";
import commonService from "@/common.service";
import SkeletonForReport from "./SkeletonForReport.vue";
import lodash from 'lodash'
export default {
  components: {
    SkeletonForReport,
  },
  props: ["filterData", "switchData"],
  data() {
    return {
      ProductionData: null,
      loading: false,
      nameWidths: [90, 120, 75, 110, 95, 130, 80, 105, 100, 115],
      accounData: [],
      projectData: [],
      sortId: null,
      sortDirection: 'asc',
      totalSortDirection: 'asc',
      backupAccountData: []
    };
  },
  created() {
    this.sortId = localStorage.getItem('LB_SORT')
    this.getProductionData();
  },
  computed: {
  },
  watch: {
    filterData() {
      if (this.filterData) {
        this.getProductionData(this.filterData);
      }
    },
  },
  methods: {
    async uniqueData() {
      this.accounData = []
      let accountId = [];
      this.projectData = []
      let projectId = [];
      if (this.ProductionData) {
        this.ProductionData.forEach((item) => {
          console.log(item, 'iiiiiii')
          if (!accountId.includes(item.account_id)) {
            this.accounData.push({ id: item.account_id, name: item.account_name })
            accountId.push(item.account_id)
          }
          if (!projectId.includes(item.project_id)) {
            this.projectData.push({ id: item.project_id, name: item.project_name, code: item.code })
            console.log(this.projectData, 'ssssssss')
            projectId.push(item.project_id)
          }
        });
        this.projectData = await commonService.getSort(this.projectData, 'name', 'asc')
        this.accounData = await commonService.getSort(this.accounData, 'name', 'asc')
        this.backupAccountData = JSON.parse(JSON.stringify(this.accounData))
      }
    },
    async getProductionData(filter) {
      this.loading = true
      let res = await ProductionDashboardService.liveBoardData(filter ? filter : {});
      this.ProductionData = res.length > 0 ? res : [];
      console.log(res, 'you')
      this.loading = false
      if (this.sortId) {
        this.getSortTheData(this.sortId)
      }
      this.uniqueData()
    },

    async getFilterDashboardData(data) {
      let obj = {};

      if (data.priority && data.priority.length > 0) {
        obj.priority = [...data.priority];
      }

      if (data.timeData && data.timeData.data_value) {
        obj.timeData = data.timeData.data_value;
      }

      let res = await ProductionDashboardService.findAll(obj);
      this.ProductionData = res.length > 0 ? res : [];
    },

    getCellValue(wId, aId) {
      let data = this.ProductionData.filter(k => k.project_id == wId && k.account_id == aId)
      if (data && data.length > 0) {
        // return !this.switchData || this.switchData =='issues' ?Math.floor(data[0].total_issues):Math.floor(data[0].estimated)
        if (!this.switchData || this.switchData === 'issues') {
          return Math.floor(data[0].total_issues);
        } else if (this.switchData === 'estimate') {
          return Math.floor(data[0].estimated);
        } else if (this.switchData === 'quantity') {
          return Math.floor(data[0].quantity);
        }

      }
    },
    // getSortTheData(wId){
    //   console.log(wId,'huhuhu',this.ProductionData,"#####")
    //   this.sortId = wId
    //   localStorage.setItem('LB_SORT',wId)
    //   const sortKey = !this.switchData || this.switchData === 'issues' ? 'total_issues' : 'estimated';
    //   console.log(this.ProductionData,'orderBy')
    //   this.ProductionData = lodash.orderBy(this.ProductionData, [
    //             (item) => item.project_id === wId ? 0 : 1,
    //             (item) => item.account_id,
    //             (item) => item[sortKey]
    //         ], ['asc', 'asc', 'asc']);
    //   this.projectData = this.ProductionData.map(i => [i.project_id, i[sortKey]])
    //   console.log(this.projectData,'higggg')
    //   this.uniqueData()
    // },

    getSortTheData(wId) {
      console.log(wId, 'W ID #');
      console.log(this.sortId, 'sort_id #')
      this.totalSortDirection = 'asc'
      if (this.sortId === wId) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortId = wId;
        this.sortDirection = 'asc';
      }

      this.sortId = wId;
      localStorage.setItem('LB_SORT', wId)
      this.sortId = wId ? wId : localStorage.getItem('LB_SORT');
      console.log(this.sortId, '$$####')
      // const sortKey = !this.switchData || this.switchData === 'issues' ? 'total_issues' : 'estimated';
      let sortKey = 'total_issues';
      if (this.switchData === 'estimated') {
        sortKey = 'estimated';
      } else if (this.switchData === 'quantity') {
        sortKey = 'quantity';
      }
      console.log(this.sortId, "sort id ###", sortKey)
      console.log(this.ProductionData, "production data ###")
      const filteredData = this.ProductionData.filter(item => item.project_id === this.sortId);
      console.log(filteredData, 'filll###')

      const sortedData = lodash.orderBy(filteredData, [sortKey, 'account_name'], [this.sortDirection]);
      console.log(sortedData, 'sort###')
      let accountIdData = []
      let $accountData = []

      for (let item of sortedData) {
        accountIdData.push(item.account_id)
        $accountData.push({ id: item.account_id, name: item.account_name })
      }
      console.log(accountIdData, 'id###')
      console.log($accountData, 'sortData#####')

      for (let item of this.backupAccountData) {
        console.log(item, '7777')
        if (!accountIdData.includes(item.id)) {
          $accountData.push(item)
        }
      }

      console.log($accountData, 'backupData####')
      this.accounData = { ...$accountData }
      console.log($accountData, "#######")
    },
    getSortTheTotalData() {
      this.sortDirection = 'desc'
      this.totalSortDirection = this.totalSortDirection === 'asc' ? 'desc' : 'asc';

      let sortKey = 'total_issues';
      if (this.switchData === 'estimated') {
        sortKey = 'estimated';
      } else if (this.switchData === 'quantity') {
        sortKey = 'quantity';
      }

      // 1. Aggregate
      const accountTotals = {};
      this.ProductionData.forEach(item => {
        const accId = item.account_id;
        const accName = item.account_name;

        if (!accountTotals[accId]) {
          accountTotals[accId] = {
            id: accId,
            name: accName,
            total_issues: 0,
            estimated: 0,
            quantity: 0,
          };
        }

        accountTotals[accId].total_issues += item.total_issues || 0;
        accountTotals[accId].estimated += item.estimated || 0;
        accountTotals[accId].quantity += item.quantity || 0;
      });

      // 2. Sort
      let accountDataSorted = Object.values(accountTotals);
      accountDataSorted = lodash.orderBy(accountDataSorted, [sortKey, 'name'], [this.totalSortDirection, 'asc']);

      // 3. Add missing
      const existingIds = new Set(accountDataSorted.map(a => a.id));
      for (const item of this.backupAccountData) {
        if (!existingIds.has(item.id)) {
          accountDataSorted.push(item);
        }
      }

      // 4. Assign to final output
      this.accounData = accountDataSorted;
    },
    getProjectData(name) {
      if (name && name.length > 15) {
        let sliced = name.slice(0, 15);
        sliced = `${sliced}...`
        return sliced
      } else {
        return name
      }
    },
    getAccountTotal(aId) {
      let total = 0;
      let data = this.ProductionData.filter(k => k.account_id == aId)
      console.log(data, 'account id !!!')
      if (!this.switchData || this.switchData == 'issues') {
        total = data.reduce((sum, project) => sum + (project.total_issues || 0), 0);
      } else if (this.switchData == 'estimate') {
        total = data.reduce((sum, project) => sum + (project.estimated || 0), 0);
      } else if (this.switchData == 'quantity') {
        total = data.reduce((sum, project) => sum + (project.quantity || 0), 0);
      }
      console.log(total, 'total issue!!!')
      return Math.floor(total);
    },

    getProjectTotal(wId) {
      let total = 0;
      let data = this.ProductionData.filter(k => k.project_id == wId)
      if (!this.switchData || this.switchData == 'issues') {
        total = data.reduce((sum, project) => sum + (project.total_issues || 0), 0);
      } else if (this.switchData === 'estimate') {
        total = data.reduce((sum, project) => sum + (project.estimated || 0), 0);
      } else if ((this.switchData == 'quantity')) {
        total = data.reduce((sum, project) => sum + (project.quantity || 0), 0);
      }
      return Math.floor(total);
    },

    issueData(pId, aId) {
      // if (pId && aId) {
      // Emitting the event with Workspace ID and Account ID
      this.$emit("workspace-clicked", {
        projectId: pId,
        accountId: aId,
      });
      // }
    },

    getTotal() {
      let total = 0;
      if (this.ProductionData) {
        this.ProductionData.forEach((item) => {
          total += item && item.total_issues ? item.total_issues : 0;
        });
      }
      return total;
    },
  },
};
</script>

<style scoped>
/* Add a class to the "Total" column to keep it fixed */
.overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

table {
  border-collapse: collapse;
  white-space: nowrap;
  width: 100%;
}


.total-column {
  position: sticky;
  left: 0;
  background-color: #eef6fb;
  z-index: 3;
}

/* Set the header and "Total" column to be fixed */
thead {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
}

/* Add padding and adjust white-space for the account name */
td.account-name {
  padding: 8px;
  /* Adjust the padding as needed */
  white-space: nowrap;
  position: relative;
  z-index: 4;
  /* Set a higher z-index to bring it to the front */
}

.scrollable-body {
  overflow-x: auto;
  max-height: 300px;
  /* Set the desired max height for the scrollable area */
}

.table-container {
  overflow-x: auto;
  max-height: 80vh;
  width: 100%;
  height: 100vh;
  overflow: auto;
}

.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 8px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #b8c5d8;
  border-radius: 8px;
}



/* ─────────────────────────────────────────
   TABLE SKELETON
───────────────────────────────────────── */
@keyframes sk-wave {
  0%   { background-position: -500px 0; }
  100% { background-position:  500px 0; }
}


/* Add a class to the "Total" column to keep it fixed */
td.total-column {
  position: sticky;
  left: 0;
  background-color: #eef6fb;
  z-index: 3;
}

/* Set the header and "Total" column to be fixed */
thead {
  position: sticky;
  top: 0;
  background: #fff;
}

/* Add padding and adjust white-space for the account name */
td.account-name {
  padding: 8px;
  /* Adjust the padding as needed */
  white-space: nowrap;
}

.scrollable-body {
  overflow: auto;
  max-height: 300px;
  /* Set the desired max height for the scrollable area */
  z-index: -1;
  /* Set the desired max height for the scrollable area */
}

.headerElem {
  white-space: nowrap;
  height: 11em;
  position: relative;
}

.headerText {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

td {
  padding: 6px;
  height: 42px;
  /* width: 50px; */
  text-align: center;
  font-size: 14px;
  font-weight: 400;
}

th:nth-child(1) {
  width: 150px !important;
  position: sticky;
  left: 0;
  background: #eef6fb;
  z-index: 3;
}

td:nth-child(1) {
  width: 150px !important;
  position: sticky;
  left: 0;
  text-align: left !important;
  font-size: 14px;
  font-weight: 700;
  background-color: #eef6fb;
}

th:last-child {
  /* width: 150px !important; */
  position: sticky;
  right: 0;
  z-index: 3;
}

td:last-child {
  /* width: 150px !important; */
  position: sticky;
  right: 0;
  font-size: 14px;
  font-weight: 700;
}

th:nth-child(odd) {
  /* width: 50px; */
}

td:nth-child(odd) {
  /* width: 50px; */
}

td:nth-child(even) {
  background: #e1eaef;
}

.rotate-90 {
  transform: rotate(90deg);
  margin: 50%;
}

/* Add these styles to your existing styles */

/* Set the first and last columns to stay fixed */
td.account-name,
td.total-column,
th.headerElem:nth-child(1),
th.headerElem.total-column {
  position: sticky;
  left: 0;
  background-color: #eef6fb;
  z-index: 3;
}

/* Set the first header cell to stay fixed */
th.headerElem:nth-child(1) {
  left: 0;
}

.total-header-cell {
  background-color: #eef6fb;
  /* Set the background color for the "Total" header cell */
}

/* Add a class for the "Total" value cells */
.total-column-cell {
  background-color: #eef6fb;
}

th.headerElem.total-column {
  position: sticky;
  left: 0;
  background-color: #eef6fb;
  z-index: 3;
  width: 20px !important;
}

/* Set the styles for the "Total" column header text */
.headerText .total-header{
  /* transform: rotate(-90deg); */
  position: relative !important;
  word-break: break-all !important;
  font-size: 16px !important;
  font-weight: 500 !important;
}

.total-header-cell{
   /* position: relative; */
  word-break: break-all;
  font-size: 16px;
  font-weight: 500;
}

/* Set the last header cell to stay fixed */
th.headerElem.total-column {
  position: sticky;
  left: auto;
  background-color: #eef6fb;
  z-index: 3;
  width: 20px !important;
}

/* Set the styles for the first column */
td.account-name {
  padding: 8px;
  /* Adjust the padding as needed */
  white-space: nowrap;
  position: relative;
  z-index: 4;
  /* Set a higher z-index to bring it to the front */
}

/* Adjust other styles as needed */

.total-row {
  position: sticky;
  bottom: 0;
  background-color: #eef6fb;
  z-index: 3;
}

.total-row td {
  font-weight: bold;
}

.headerElem:nth-child(even) {
  background: #e1eaef;
  width: 20px !important;
}


.first-column {
  width: auto;
  /* Let the width be determined by content */
}

.sort {
  display: inline-flex;
  align-items: center;
}

.sort1 {
  display: inline-flex;
  align-items: center;
}

.sort-top {
  padding-top: 10px;
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
}

/* Add a general style for other columns */
.table-container th:not(.first-column),
.table-container td:not(.first-column) {
  width: 30px !important;
  overflow: hidden;
  /* You can customize other styles here */
}

.no-data-cell {
  padding: 0 !important;
  height: 280px;
  background: #ffffff;
  border-bottom: 1px solid #edf1f7;
  text-align: center;
}

.empty-state {
  min-height: 280px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 26px 16px;
  overflow: hidden;
}

.empty-visual {
  width: 100px;
  height: 94px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}

.empty-orbit {
  position: absolute;
  border: 1px solid rgba(75, 123, 225, 0.12);
  border-radius: 50%;
  transform: rotate(-25deg);
}

.empty-orbit-one {
  width: 94px;
  height: 58px;
}

.empty-orbit-two {
  width: 72px;
  height: 88px;
  transform: rotate(35deg);
  border-color: rgba(139, 92, 246, 0.12);
}

.empty-icon-card {
  position: relative;
  z-index: 1;
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4778dc;
  border: 1px solid rgba(105, 139, 221, 0.2);
  border-radius: 19px;
  background: linear-gradient(145deg, #ffffff 5%, #edf3ff 100%);
  box-shadow:
    0 8px 20px rgba(67, 105, 190, 0.10),
    0 2px 5px rgba(67, 105, 190, 0.05),
    inset 0 1px 0 #ffffff;
  animation: empty-float 3s ease-in-out infinite;
}

.empty-spark {
  position: absolute;
  z-index: 2;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.spark-one {
  top: 14px;
  right: 17px;
  background: #8b72f5;
  box-shadow: 0 0 9px rgba(139, 114, 245, 0.35);
}

.spark-two {
  bottom: 17px;
  left: 14px;
  width: 5px;
  height: 5px;
  background: #58b5f6;
}

.spark-three {
  top: 30px;
  left: 7px;
  width: 4px;
  height: 4px;
  background: #b1a0fa;
}

.empty-state-title {
  color: #24324a;
  font-size: 15px;
  font-weight: 650;
  letter-spacing: -0.3px;
  line-height: 1.5;
  margin-bottom: 5px;
}

.empty-state-description {
  color: #8793a7;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.7;
  max-width: 320px;
}

.empty-state-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 16px;
  padding: 6px 11px;
  border: 1px solid #edf0f6;
  border-radius: 20px;
  background: #f8faff;
  color: #78869c;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.2px;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #a0aec0;
  box-shadow: 0 0 0 3px rgba(160, 174, 192, 0.12);
}

@keyframes empty-float {
  0%, 100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-4px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .empty-icon-card {
    animation: none;
  }
}
</style>
